import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NWSVolumeLayout } from "../NWSVolumeLayout";
import { NWSVolumeEntities } from "../NWSVolumeEntities";
import { NWSVolumeRouterProps } from "../NWSVolumeRouterProps";

export interface VolumeListPageProps extends NSARouterMakerResult, NWSVolumeRouterProps { }

class VolumeListPage extends Component<VolumeListPageProps>
{
    override render()
    {
        return (
            <NWSVolumeLayout
                {...this.props}
                pages={{
                    entity: NWSVolumeEntities.volume(this.props),
                    list: {}
                }}
            >
                <></>
            </NWSVolumeLayout>
        );
    }
}

export default VolumeListPage;